import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import ProductCard from "./ProductCard";
import LoadingSpinner from "./components/LoadingSpinner";
import "./App.css";
import { getOrFetch } from "./utils/apiCache";

function BestSellingPage() {
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setIsLoading(true);
        const data = await getOrFetch(
          "bestselling:per_page:100",
          () =>
            axios
              .get("https://floriakw.com/wp-json/wc/v3/products", {
                auth: {
                  username: "ck_39cd5450af63b97a35e502d9a0a75925866fefab",
                  password: "cs_15701bd9b4392a3b6e5a3d5fa4d326d7acb0a0bf",
                },
                params: {
                  orderby: "popularity",
                  order: "desc",
                  per_page: 100,
                  status: "publish",
                },
              })
              .then((r) => r.data),
          { ttlMs: 10 * 60 * 1000 }
        );
        setProducts(data);
        setError(null);
      } catch (err) {
        console.error("Best selling full error:", err);
        setError("فشل في تحميل المنتجات الأكثر مبيعًا. يرجى المحاولة مرة أخرى لاحقًا.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchProducts();
  }, []);

  if (isLoading) {
    return (
      <div className="category-page">
        <div className="container">
          <nav className="breadcrumb">
            <Link to="/">الرئيسية</Link> / <span>الأكثر مبيعا</span>
          </nav>
          <div className="loading-container">
            <LoadingSpinner size="medium" color="black" withText={true} />
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="category-page">
        <div className="container">
          <nav className="breadcrumb">
            <Link to="/">الرئيسية</Link> / <span>الأكثر مبيعا</span>
          </nav>
          <div className="error-message">
            <p>{error}</p>
            <button 
              onClick={() => window.location.reload()} 
              className="retry-button"
            >
              إعادة المحاولة
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="category-page">
      <div className="container">
        <nav className="breadcrumb">
          <Link to="/">الرئيسية</Link> / <span>الأكثر مبيعا</span>
        </nav>

        {products.length === 0 ? (
          <div className="no-products">
            <p>لا توجد منتجات في هذا القسم.</p>
          </div>
        ) : (
          <>
            <p className="results-count">عرض {products.length} من كل النتائج</p>
            <div className="grid category-products">
              {products.map((product) => (
                <ProductCard key={product.id} product={product} />
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default BestSellingPage;
